import { CardContent, CardHeader, Grid } from "@dealer-center/core-components";
import type { AccountEntity } from "@dealer-center/ddc-api-account-interface";
import {
  PagesLandingPageListItem,
  StyledUnorderedList
} from "@dealer-center/ddc-core-custom-components";
import { useOutletContext } from "react-router-dom";
import { StyledCard } from "./styledCard";
import type { IDashboardProps } from "@dealer-center/ddc-pages-dashboard-interface";

export const DealerHours = (props: IDashboardProps) => {
  const { isEdit } = props;
  const { accountEntity } = useOutletContext<{
    accountEntity: AccountEntity;
  }>();

  if (
    !accountEntity.hours ||
    (!accountEntity.hours.monday &&
      !accountEntity.hours.tuesday &&
      !accountEntity.hours.wednesday &&
      !accountEntity.hours.thursday &&
      !accountEntity.hours.friday &&
      !accountEntity.hours.saturday &&
      !accountEntity.hours.sunday)
  ) {
    return null;
  }

  return (
    <Grid size={!isEdit ? { lg: 3, sm: 6, xs: 12 } : 12}>
      <StyledCard
        content={
          <CardContent>
            <StyledUnorderedList>
              <PagesLandingPageListItem
                label="Monday"
                type={isEdit ? "disabledInput" : undefined}
                value={accountEntity.hours.monday}
              />
              <PagesLandingPageListItem
                label="Tuesday"
                type={isEdit ? "disabledInput" : undefined}
                value={accountEntity.hours.tuesday}
              />
              <PagesLandingPageListItem
                label="Wednesday"
                type={isEdit ? "disabledInput" : undefined}
                value={accountEntity.hours.wednesday}
              />
              <PagesLandingPageListItem
                label="Thursday"
                type={isEdit ? "disabledInput" : undefined}
                value={accountEntity.hours.thursday}
              />
              <PagesLandingPageListItem
                label="Friday"
                type={isEdit ? "disabledInput" : undefined}
                value={accountEntity.hours.friday}
              />
              <PagesLandingPageListItem
                label="Saturday"
                type={isEdit ? "disabledInput" : undefined}
                value={accountEntity.hours.saturday}
              />
              <PagesLandingPageListItem
                label="Sunday"
                type={isEdit ? "disabledInput" : undefined}
                value={accountEntity.hours.sunday}
              />
            </StyledUnorderedList>
          </CardContent>
        }
        header={<CardHeader title="Dealer Hours" />}
      />
    </Grid>
  );
};
